export const tokenName = 'alpacaToken';
export const setToken = (token: string) => {
  localStorage.setItem(tokenName, token);
};
export const getToken = () => {
  return localStorage.getItem(tokenName);
};
export const clearToken = () => {
  localStorage.removeItem(tokenName);
};
